import { render, staticRenderFns } from "./flightSearch.vue?vue&type=template&id=db2bd5b2&"
import script from "./flightSearch.vue?vue&type=script&lang=js&"
export * from "./flightSearch.vue?vue&type=script&lang=js&"
import style0 from "./flightSearch.vue?vue&type=style&index=0&id=db2bd5b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports